import React, { useState } from 'react';
import { useHistory } from 'react-router';

// block groups
import BaseTable from '../../../../../blockGroups/table/BaseTable/BaseTable.blockgroup';

// components
import { Box, Container } from '@mui/system';
import { Typography } from '@mui/material';

// utils
import { cleanRequestsData } from './JobDetailEquipmentRequests.collection.utils';
import { dateComparator } from '../../../../../shared/sorting/dates';

const equipmentRequestsColumnConfigs = [
    { 
        name: "date", 
        title: "Date", 
        objectFieldsToDisplay: ["date"],
        objectFieldsDelimeter: "", 
        useNestedObject: false,
        type: "date",
        sortComparator: dateComparator
    },
    { 
        name: "requestedBy", 
        title: "Requested By", 
        objectFieldsToDisplay: ["requestedBy"],
        objectFieldsDelimeter: "", 
        useNestedObject: false 
    },
    { 
        name: "numItems", 
        title: "# of Items", 
        objectFieldsToDisplay: ["numItems"],
        objectFieldsDelimeter: "", 
        useNestedObject: false,
        type: 'number',
        align: 'left',
        headerAlign: 'left'
    },
    { 
        name: "status", 
        title: "Status", 
        objectFieldsToDisplay: ["status"],
        objectFieldsDelimeter: "", 
        useNestedObject: false 
    },
    { 
        name: "dateFullfilled", 
        title: "Date Fullfilled", 
        objectFieldsToDisplay: ["dateFullfilled"],
        objectFieldsDelimeter: "", 
        useNestedObject: false,
        type: "date",
        sortComparator: dateComparator
    },
];

const JobDetailEquipmentRequests = ({data = { job: {jobEquipmentRequests: []} }, loading, error}) => {
    const history = useHistory()
    const [sortModel, setSortModel] = useState([{ field: "date", sort: "desc"}])

    const handleRowClick = (rowData) => {
        history.push(`/inventory/equipment-requests/${rowData.id}`)
    }

    const cleanedData = [...cleanRequestsData(data.job.jobEquipmentRequests)]

    return (<Container maxWidth={false} disableGutters sx={{ marginTop: 8, marginBottom: 8}}>
        <Typography variant='h4'>Equipment Requests</Typography>
        <Box sx={{ height: 500, width: "100%", marginTop: 2}}>
            <BaseTable
                rawData={cleanedData} 
                columnConfigs={equipmentRequestsColumnConfigs} 
                loading={loading} 
                onRowClick={handleRowClick}
                sortModel={sortModel}
                onSortModelChange={(newSortModel) => setSortModel(newSortModel)}
            />
        </Box>
    </Container>
    )
}

export default JobDetailEquipmentRequests;